import { allProgress } from '../exercise/exercise'
import { formatMoney } from '../lib/money'
import { navigate } from '../lib/router'
import { savingsView } from '../savings/savings'
import { useStore } from '../store'
import { TopBar } from '../ui/parts'
import { SECTIONS, isHidden, type SectionId } from './sections'

/**
 * A drawer for everything that does not deserve a slot in the bottom bar. Keeping the
 * navigation at six items means each one stays wide enough to hit.
 *
 * Settings is not one of the toggleable sections — it is the screen you would need to get
 * back to after hiding something, so it is always here.
 */
export function OtherScreen() {
  const { snapshot } = useStore()
  if (!snapshot) return null

  const hidden = snapshot.app.hiddenSections
  const exercises = allProgress(snapshot.exercise, 'all')
  const logged = snapshot.exercise.logs.length
  const savings = savingsView(snapshot.savings)
  const recipes = snapshot.cookbook.recipes.length

  const blurbs: Record<SectionId, string> = {
    budget: '',
    nutrition: '',
    health: '',
    todo: '',
    cookbook:
      recipes === 0
        ? 'Save recipes from a link'
        : `${recipes} recipe${recipes === 1 ? '' : 's'} saved`,
    savings:
      savings.targetFils === 0
        ? 'Set a goal and track what you have put aside'
        : `${formatMoney(savings.currentFils)} of ${formatMoney(savings.targetFils)} AED`,
    exercise:
      exercises.length === 0
        ? 'Add exercises and track progressive overload'
        : `${exercises.length} exercise${exercises.length === 1 ? '' : 's'} · ${logged} set${logged === 1 ? '' : 's'} logged`,
    game: 'Spin for what happens next',
    emergency: 'Nothing here yet',
  }

  const drawer = SECTIONS.filter((s) => !s.inNav && !isHidden(hidden, s.id))

  return (
    <div className="screen">
      <TopBar title="Other" />

      <div className="stack">
        {drawer.map((section) => (
          <button
            type="button"
            className="app-card"
            key={section.id}
            onClick={() => navigate(section.route)}
          >
            <div className="card-title">{section.label}</div>
            <div className="muted" style={{ fontSize: 13, marginTop: 2 }}>
              {blurbs[section.id]}
            </div>
          </button>
        ))}

        <button type="button" className="app-card" onClick={() => navigate('/settings')}>
          <div className="card-title">Settings</div>
          <div className="muted" style={{ fontSize: 13, marginTop: 2 }}>
            Choose which sections to show
          </div>
        </button>
      </div>
    </div>
  )
}
